(function () {
    const observedDrawers = new WeakSet(); // para no observar el mismo dos veces

    function isDrawerOpen(el) {
        const content = el.querySelector('.cart_content');
        return (
            el.classList.contains('active_link') ||
            el.classList.contains('active-link') ||
            el.classList.contains('open') ||
            el.classList.contains('is-open') ||
            (content &&
                window.getComputedStyle(content).display !== 'none' &&
                !content.classList.contains('hidden'))
        );
    }

    function injectRecommendedProducts() {
        getIguanaDrawerRecommendedItems();

        /* if (document.querySelector('.recommended-products')) return;

        const section = document.createElement('div');
        section.className = 'recommended-products';
        section.style.padding = '15px';
        section.style.borderTop = '1px solid #ddd';
        section.style.background = '#fafafa';
        section.innerHTML = `
            <h4 style="margin-bottom:10px;">Productos recomendados</h4>
            <ul style="list-style:none;padding:0;">
                <li>⭐ Producto de ejemplo 1</li>
                <li>⭐ Producto de ejemplo 2</li>
                <li>⭐ Producto de ejemplo 3</li>
            </ul>
        `;

        const openDrawer = [...document.querySelectorAll('.cart-container')].find(isDrawerOpen);
        if (openDrawer) {
            const inner = openDrawer.querySelector('.cart_content');
            (inner || openDrawer).appendChild(section);
        } */
    }

    function observeDrawer(drawer) {
        if (observedDrawers.has(drawer)) return; // ya observado
        observedDrawers.add(drawer);

        console.log('👀 Observando nuevo cart-container', drawer);

        const observer = new MutationObserver(() => {
            const isOpen = isDrawerOpen(drawer);
            if (isOpen) {
                console.log('🟢 Carrito abierto');
                injectRecommendedProducts();
            } else {
                console.log('X Carrito cerrado');
                /* const block = drawer.querySelector('.recommended-products');
                if (block) block.remove(); */
            }
        });

        observer.observe(drawer, {
            attributes: true,
            attributeFilter: ['class', 'style'],
            subtree: true,
        });
    }

    function init() {
        // Detectar los que ya existen
        document.querySelectorAll('.cart-container').forEach(observeDrawer);

        // Observar si aparecen nuevos
        const globalObserver = new MutationObserver((mutations) => {
            for (const m of mutations) {
                m.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) {
                        if (node.matches('.cart-container')) {
                            observeDrawer(node);
                        } else if (node.querySelector && node.querySelector('.cart-container')) {
                            node.querySelectorAll('.cart-container').forEach(observeDrawer);
                        }
                    }
                });
            }
        });

        globalObserver.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

function getIguanaDrawerRecommendedItems() {
    console.log("getIguanaDrawerRecommendedItems start");

    // 1. Define the selector for all your cart drawers
    let cartDrawerSelector = '.iguana-cart-suggestion'; // Use a specific class or a general selector

    // 2. Define the URL for the new content (must return the content for all instances)
    let fetchUrl = '/sections?section_id=single-product-card';

    // 3. Fetch the new content once
    fetch(fetchUrl).then(response => {
        if (!response.ok) {
            throw new Error("HTTP error! status: " + response.status);
        }
        return response.text();
    }).then(html => {
        // console.log( html );
        // 4. Find all matching elements and iterate over them
        let targetDrawers = document.querySelectorAll(cartDrawerSelector);

        if (targetDrawers.length > 0) {
            targetDrawers.forEach((drawer, index) => {
                // 5. Update the content of each matching element
                drawer.innerHTML = html;

                console.log("Updated cart drawer instance " + (index + 1));
            });
            console.log("Successfully updated " + targetDrawers.length + " cart drawer(s)");
        } else {
            console.warn("No elements found with selector: iguana-cart-suggestion");
        }
    }).catch(error => {console.error('Fetch error:', error);

    });
}